import React from "react"

const importedComponents = (componentContent) => {
    const components = {}
    for (let i = 0; i < componentContent.length; i++) {
        components[componentContent[i].component] = React.lazy(() =>
            import(`../pages/${componentContent[i].path}`))
    }
    return components
}

export default {
    importedComponents
}